import { useMutation } from "@apollo/client";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DatePicker, Form, Input, message, Modal } from "antd";
import { useState } from "react";
import Swal from "sweetalert2";
import { CancellAllResponseTaskByTemplateIdMutation } from "@src/util/mutation/mobileServices.mutation";
import dayjs from "dayjs";
import { cancelResponseByIdMutation } from "@src/util/mutation/mobileServices.mutation.js";
import Spinner from "@src/components/spinner";


export const CancelTaskModal = ({visible, onClose, templateId, taskId})=>{
    const [cancelAllOption, setCancelAllOption] = useState(false);
    const [reason, setReason] = useState("");
    const [effectiveDate, setEffectiveDate] = useState("");
    const [comments, setComments] = useState("");
    const [isContine, setContine] = useState(false);

    const[CancellAllResponseTaskByTemplateId, {loading, error}]=useMutation(CancellAllResponseTaskByTemplateIdMutation);

    const handelCancelAll= async ()=>{
        const res = await Swal.fire({
            icon: 'warning',
            title: 'Do you really want to cancel all tasks?',
            text: 'This action cannot be undone and will also stop automatic scheduling.',
            showCancelButton: true,
            confirmButtonText: 'YES, Cancel All',
            cancelButtonText: 'NO',
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            reverseButtons: true // puts NO on the left, YES on the right (safer UX)
        });
          
        if (res.isConfirmed) {
        // user clicked YES
            await CancellAllResponseTaskByTemplateId({
                variables:{
                    templateId: templateId,
                    date: effectiveDate,
                    reason: reason,
                    comments: comments || ""

                }
            });
            message.success("All Tasks were successfully cancelled ");
            onClose()
        } else {
        // user clicked NO or closed
        console.log('Action cancelled');
        }
    }

  const [cancelResponseById, {loading: cancelResponseLoading}] = useMutation(cancelResponseByIdMutation);


    const handelCancelTask = async()=>{
        try{
                // Call your mutation / API with reason & comment
            await cancelResponseById({
                variables: {
                responseId: taskId,
                reason,
                comments: comments || ""
                }
            });
            message.success("Task was successfully cancelled ");
            onClose();
        }
        catch(err){
            console.log(err, "eerr")
            message.error("Please try later");
        }
    }

    return(

        <Modal
            open={visible}
            footer={null
            }
            closable={false}
        >

            <div className='modal-header-title' style={{padding:'16px 40px'}}>
                <span style={{letterSpacing:'0.2px'}}> 
                    Cancel Service Task
                </span>
                <span  onClick={async()=>{onClose()}}><FontAwesomeIcon className='close' icon={faClose}/></span>
            </div>


          

            {cancelResponseLoading?
                <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <Spinner/>
                </div>
                
            :
                isContine?
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <div style={{
                        color: '#DC3545',
                        fontWeight: '600',
                        fontSize: '14px',
                        marginBottom: '4px'
                    }}>
                        This action cannot be undone.
                    </div>
                    <div style={{
                        color: '#6c757d',
                        fontSize: '13px',
                        marginBottom: '24px'
                    }}>
                        Select one of the following
                    </div>
                    {
                        cancelAllOption?
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <Form.Item>
                                <label style={{fontWeight:'bold'}}>Effective Date From</label>
                                <DatePicker 
                                    className="generic-input-control"
                                    format={"DD/MM/YYYY"}
                                    onChange={(date)=>setEffectiveDate(dayjs(date).toISOString())}
                                />
                            </Form.Item>
                            <div style={{display:'flex', justifyContent:'space-between'}}>
                                <button className="drawer-outlined-btn" onClick={()=>setCancelAllOption(false)}>Back</button>
                                <button className="drawer-filled-btn" onClick={handelCancelAll}>Cancel All</button>
                            </div>
                        </div>
                        :

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <button className="drawer-outlined-btn"
                                onClick={handelCancelTask}
                            >Cancel This Task Only</button>
                            {templateId? 
                            <button className="drawer-filled-btn" onClick={()=>setCancelAllOption(true)}>Cancel All Tasks</button>
                            :null}
                        </div>
                    }
                </div>
                :
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <select className="generic-input-control" onChange={(e)=>setReason(e?.target.value)} style={{ margin: '20px', width:'80%' }} >
                        <option value="">Select reason</option>
                        <option value="Contract Ended">Contract Ended</option>
                        <option value="Site Closed">Site Closed</option>
                        <option value="Client Terminated">Client Terminated</option>
                        <option value="Non-payment">Non-payment</option>
                        <option value="Other">Other</option>
                    </select>
                    {
                        reason=="Other"?
                        <>
                            <Input
                                placeholder="Comments"
                                className="generic-input-control"
                                style={{ margin: '20px', width:'80%' }}
                                onChange={(e)=>setComments(e.target.value)}
                            />
                        </>
                        :null
                    }
                    <button disabled={reason?.length==0} className={reason?.length==0?" disabled-btn drawer-outlined-btn " :"drawer-outlined-btn"} onClick={()=>setContine(true)}>Continue</button>
                </div>
            }

        </Modal>

      
    );
};